import React, { useCallback } from "react";
import { DocumentFilled } from "@fluentui/react-icons";

type ChatFileUploadButtonProps = {
    onFilesSelected: (files: FileList | null) => void;
};

export const ChatFileUploadButton: React.FC<ChatFileUploadButtonProps> = (props) => {
    const { onFilesSelected } = props;
    const fileInputRef = React.useRef<HTMLInputElement>(null);

    const handleButtonClick = useCallback(() => {
        fileInputRef.current?.click();
    }, [fileInputRef]);

    const handleFileChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        onFilesSelected(event.target.files);
    }, [onFilesSelected]);

    return (
        <div style={{ display: "flex", alignItems: "center", height: "100%" }}>
            <input
                ref={fileInputRef}
                name="file"
                type="file"
                multiple
                style={{ display: "none" }}
                onChange={handleFileChange}
            />
            <button
                style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                }}
                onClick={handleButtonClick}
            >
                <DocumentFilled fontSize={24} />
            </button>
        </div>
    );
};
